import { h, Fragment } from "preact";
import { Edit } from "../../helpers/icons";
import StockStatus from "../stock-status/stock-status";
import ProductSetItemFormDrawer from "./product-set-item-form-drawer";
import setItemLayouts from "./setItemLayouts";
import ProductSetItemFormInline from "./product-set-item-form-inline";

export default function ProductSetItem({
  product,
  item,
  inStock,
  waitlist,
  orderable,
  itemId,
  formStyle = setItemLayouts.drawer,
  idPrefix,
  enableAvailabilityPreview,
  updateItem,
}) {
  if (!product) return null;

  const { variant } = item;

  const variantId = variant.id.replace("gid://shopify/ProductVariant/", "");
  const variantUrl = `${product.helpers.url}?variant=${variantId}`;

  return (
    <div
      className={`product-set-item ${!inStock || !orderable ? "product-set-item--out-of-stock" : ""}`}
    >
      <button type="button" className="product-set-item__image-wrapper">
        <quickview-trigger
          URL={variantUrl.toString()}
          SECTION-ID="quickview-set-item"
          SET-ITEM-ID={itemId}
          QUANTITY={item.quantity}
        ></quickview-trigger>
        {variant.image ? (
          <img
            className={`product-set-item__image ${!inStock || !orderable ? "product-set-item__image--out-of-stock" : ""}`}
            src={window.getSizedImageUrl(variant.image.url, "x160")}
            alt=""
          />
        ) : (
          <div className="product-set-item__image product-set-item__image--placeholder"></div>
        )}
      </button>
      {formStyle === setItemLayouts.drawer && (
        <ProductSetItemFormDrawer
          product={product}
          item={item}
          itemId={itemId}
          waitlist={waitlist}
        />
      )}
      {formStyle === setItemLayouts.inline && (
        <ProductSetItemFormInline
          product={product}
          item={item}
          itemId={itemId}
          idPrefix={idPrefix}
          enableAvailabilityPreview={enableAvailabilityPreview}
          updateItem={updateItem}
          waitlist={waitlist}
          orderable={orderable}
        />
      )}
      {!inStock && orderable && (
        <div className="product-set-item__oos-add-warning">
          {window.localeStrings.product.set_confirm_add_waitlist}
        </div>
      )}
      {waitlist && (
        <back-in-stock-button
          className="product-set-item__bis-button-wrapper"
          SELECTED-VARIANT={variantId}
          URL={variantUrl}
        >
          <button
            type="button"
            class="product-set-item__bis-button link link--black"
            data-bis-button
          >
            {window.localeStrings.product.notify_me}
          </button>
        </back-in-stock-button>
      )}
    </div>
  );
}
